export default{
    user:{},
    token:'',
    msg:'',
    configuracaogeral:false,
    editar:{},
    listanotificao:'',
}